module.exports = __webpack_public_path__ + "media/rabia giff send ratio.1a00cbab.mp4";